const products = [

  {
    id: 29,
    name: 'Cosmic Candy',
    strain: 'Indica',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 180 },
      { option: '1/2oz', price: 100 },
      { option: '1/4oz', price: 70 },
      { option: '3.5g', price: 50 },
    ],
    image: '/images/blue.png',
    category: 'Exotic-Flower',
    isNew: true,
    description: 'As an indica-dominant hybrid,cCosmic Candy is known for delivering total mind and body relaxation.',
    effects: ['Euphoric', 'Deep relaxation', 'Pain relief'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  {
    id: 30,
    name: 'Alpha Purple',
    strain: 'Hybrid',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 180 },
      { option: '1/2oz', price: 100 },
      { option: '1/4oz', price: 70 },
      { option: '3.5g', price: 50 },

    ],
    image: '/images/icek.png',
    category: 'Exotic-Flower',
    isNew: true,
    description: 'As an indica-dominant hybrid, known for its uplifting, cerebral effects that boost creativity and energy.',
    effects: ['Euphoric', 'Creative', 'Energetic'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  {
    id: 28,
    name: 'Biscotti',
    strain: 'Indica',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 180},
      { option: '1/2oz', price: 100 },
      { option: '1/4oz', price: 70 },
      { option: '3.5g', price: 50 },

    ],
    image: '/images/phaze.png',
    category: 'Exotic-Flower',
    isNew: true,
    description: 'An indica dominant hybrid with a sweet berry aroma and euphoric effects.',
    effects: ['Euphoric', 'Creative', 'Energetic'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  {
    id: 31,
    name: 'Super Lemon',
    strain: 'Sativa',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 180 },
      { option: '1/2oz', price: 100 },
      { option: '1/4oz', price: 70 },
      { option: '3.5g', price: 50 },
    ],
    image: '/images/og.png',
    category: 'Exotic-Flower',
    isNew: true,
    description: 'Super Lemon is a legendary sativa-dominant strain known for its tropical flavors and uplifting effects.',
    effects: ['Euphoric', 'Creative', 'Energetic'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  {
    id: 32,
    name: 'GMO Cookies',
    strain: 'Indica',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 130 },
      { option: '1/2oz', price: 70 },
      { option: '1/4oz', price: 50 },
    ],
    image: '/images/gpp.png',
    category: 'Exotic-Flower',
    isNew: true,
    description: 'GMO Cookie strain is a heavy hitter that is roughly 90% indica and 10% sativa.',
    effects: ['Euphoric', 'Deep relaxation', 'Pain relief'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  {
    id: 3,
    name: 'Sour Diesel',
    strain: 'Sativa',
    // thcContent: 20,
    priceOptions: [
      { option: '1oz', price: 130 },
      { option: '1/2oz', price: 70 },
      { option: '1/4oz', price: 50 },
    ],
    image: '/images/sdd.png',
    category: 'Exotic-Flower',
    isNew: false,
    description: 'A potent sativa with diesel-like aroma and energizing effects.',
    effects: ['Energetic', 'Creative', 'Uplifted'],
    flavors: ['Diesel', 'Citrus', 'Pungent']
  },
  // Flower (8 products)
  {
    id: 1,
    name: 'Cherry Cheesecake',
    strain: 'hybrid',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 130 },
      { option: '1/2oz', price: 70 },
      { option: '1/4oz', price: 50 },
    ],
    image: '/images/weed.png',
    category: 'Flower',
    isNew: true,
    description: 'Cherry Cheese is a flavorful hybrid that blends the creamy, skunky depth of classic Cheese genetics with bright red-berry and stone-fruit tones',
    effects: ['Euphoric', 'Creative', 'Energetic'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  {
    id: 2,
    name: 'Apple Fritter',
    strain: 'hybrid',
    // thcContent: 23,
    priceOptions: [
      { option: '1oz', price: 130 },
      { option: '1/2oz', price: 70 },
      { option: '1/4oz', price: 50 },
    ],
    image: '/images/bubbler.png',
    category: 'Flower',
    isNew: true,
    description: 'a balanced hybrid strain with sweet apple flavors and potent effects. Ideal for stress relief, Relaxing and pain management.',
    effects: ['Relaxing', 'Sleepy', 'Happy'],
    flavors: ['Earthy', 'Pine', 'Woody']
  },
  {
    id: 4,
    name: 'Granddaddy Purple',
    strain: 'Indica',
    // thcContent: 22,
    priceOptions: [
      { option: '1oz', price: 100 },
      { option: '1/2oz', price: 60 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/jack.png',
    category: 'Flower',
    description: 'A famous indica with grape and berry flavors, perfect for relaxation.',
    effects: ['Relaxing', 'Sleepy', 'Euphoric'],
    flavors: ['Grape', 'Berry', 'Sweet']
  },
  {
    id: 5,
    name: 'Green Crack',
    strain: 'Sativa',
    // thcContent: 19,
    priceOptions: [
      { option: '1oz', price: 100 },
      { option: '1/2oz', price: 60 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/gcc.png',
    category: 'Flower',
    description: 'An energetic sativa with mango and citrus flavors.',
    effects: ['Energetic', 'Focused', 'Happy'],
    flavors: ['Mango', 'Citrus', 'Tropical']
  },
  {
    id: 6,
    name: 'Bubba Kush',
    strain: 'hybrid',
    // thcContent: 21,
    priceOptions: [
      { option: '1oz', price: 100 },
      { option: '1/2oz', price: 60 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/dv.png',
    category: 'Flower',
    isNew: true,
    description: 'Bubba Kush is, heavily indica-dominant hybrid known for its tranquilizing, full-body relaxation and distinctive earthy, coffee-chocolate flavor profile.',
    effects: ['Relaxing', 'Sleepy', 'Peaceful'],
    flavors: ['Earthy', 'Sweet', 'Pine']
  },
  // {
  //   id: 7,
  //   name: 'Jack Herer',
  //   strain: 'Sativa',
  //   // thcContent: 18,
  //   priceOptions: [
  //     { option: '1oz', price: 100 },
  //     { option: '1/2oz', price: 60 },
  //     { option: '1/4oz', price: 40 },
  //   ],
  //   image: '/images/jack.png',
  //   category: 'Flower',
  //   isNew: true,
  //   description: 'A legendary sativa with spicy pine flavor and clear-headed effects.',
  //   effects: ['Creative', 'Focused', 'Uplifted'],
  //   flavors: ['Pine', 'Spicy', 'Woody']
  // },
  // {
  //   id: 8,
  //   name: 'Wedding Cake',
  //   strain: 'Hybrid',
  //   // thcContent: 25,
  //   priceOptions: [
  //     { option: '1oz', price: 100 },
  //     { option: '1/2oz', price: 60 },
  //     { option: '1/4oz', price: 40 },
  //   ],
  //   image: '/images/weed.png',
  //   category: 'Flower',
  //   description: 'A potent hybrid with sweet vanilla flavor and balanced effects.',
  //   effects: ['Relaxed', 'Happy', 'Euphoric'],
  //   flavors: ['Vanilla', 'Sweet', 'Creamy']
  // },

  // Edibles (5 products)
  // {
  //   id: 9,
  //   name: 'Trolli Gummi Candy',
  //   strain: 'Hybrid',
  //   thcContent: 600 ,
  //   price: 25,
  //   image: '/images/troll.png',
  //   category: 'Edibles',
  //   isNew: true,
  //   description: 'Trolli Gummi Candy with 600mg THC each (6 pieces x 100 special offer).',
  //   effects: ['Strong','Happy', 'Relaxed'],
  //   flavors: ['Sour', 'Sweet', 'Fruity'],
  //   dosage: '10mg THC per piece'
  // },
  {
    id: 10,
    name: 'Faded Gummi',
    strain: 'Indica',
    thcContent: 1000,
    price: 25,
    image: '/images/fad.png',
    category: 'Edibles',
    isNew: true,
    description: 'Faded Gummi with 1000mg THC each (5 pieces x 100 special offer).',
    effects: ['Strong','Happy', 'Relaxed'],
    flavors: ['Sativa', 'Indica', 'Hybrid'],
    dosage: '10mg THC per piece'
  },
  {
    id: 11,
    name: 'Trolli Gummi',
    strain: 'Sativa',
    thcContent: 500,
    price: 25,
    image: '/images/trr.png',
    category: 'Edibles',
    description: 'Trolli Gummi with 600mg THC each (5 pieces x 100 special offer).',
    effects: ['Strong','Happy', 'Relaxed'],
    flavors: ['Sativa', 'Indica', 'Hybrid'],
    dosage: '5mg THC per piece'
  },
  {
    id: 12,
    name: 'Peach Gummi',
    strain: 'Hybrid',
    thcContent: 600,
    price: 25,
    image: '/images/gmm.png',
    category: 'Edibles',
    description: 'Peach Gummi with 600mg THC each (5 pieces x 100 special offer).',
    effects: ['Strong','Happy', 'Relaxed'],
    flavors: ['Sativa', 'Indica', 'Hybrid'],
    dosage: '20mg THC per piece'
  },
  {
    id: 13,
    name: 'Sour rings',
    strain: 'Hybrid',
    thcContent: 600,
    cbdContent: 5,
    price: 25,
    image: '/images/ring.png',
    category: 'Edibles',
    description: 'Sour rings Gummi with 600mg THC each (5 pieces x 100 special offer).',
    effects: ['Strong','Happy', 'Relaxed'],
    flavors: ['Sativa', 'Indica', 'Hybrid'],
    dosage: '5mg THC + 5mg CBD per piece'
  },

  // Concentrates (2 products)
  {
    id: 14,
    name: 'Tincture',
    strain: '1000MG THC Tincture',
    // thcContent: 50,
    price: 50,
    image: '/images/tink.png',
    category: 'Concentrates',
    description: 'THC tinctures emerge as an ideal choice for non-smokers or those seeking a discreet and rapidly effective cannabis solution.',
    effects: ['Strong', 'Euphoric', 'Creative'],
    flavors: ['Dank', 'Pine', 'Citrus'],
    consistency: 'Sauce'
  },
  // {
  //   id: 15,
  //   name: 'Shatter',
  //   strain: '5g shatter',
  //   // thcContent: 80,
  //   price: 50,
  //   image: '/images/shtt.png',
  //   category: 'Concentrates',
  //   description: 'Glass-like concentrate with high potency and clean flavor.',
  //   effects: ['Potent', 'Relaxing', 'Sleepy'],
  //   flavors: ['Earthy', 'Sweet', 'Pungent'],
  //   consistency: 'Glass-like'
  // },

  // Cartridges (4 products)
  {
    id: 16,
    name: 'Raw Garden',
    strain: 'indica',
    // thcContent: 85,
    price: 30,
    image: '/images/raw.png',
    category: 'cart',
    description: 'Raw Garden vape cartridges generally offer a sweet, fruity flavor profile with indica-dominant effects.',
    effects: ['Happy', 'Relaxed', 'Euphoric'],
    flavors: ['Sweet', 'Creamy', 'Berry'],
    cartridgeType: '510 Thread'
  },
  {
    id: 17,
    name: 'Muha Meds',
    strain: 'indica',
    // thcContent: 82,
    price: 30,
    image: '/images/muha.png',
    category: 'cart',
    description: 'Muha Meds Carts delivers a refreshing and juicy experience, reminiscent of biting into a ripe watermelon.',
    effects: ['Energetic', 'Creative', 'Uplifted'],
    flavors: ['euphoria', 'Citrus', 'relief', 'relaxation'],
    cartridgeType: '510 Thread'
  },
  {
    id: 18,
    name: 'Friendly Farms',
    strain: 'Indica',
    // thcContent: 83,
    price: 30,
    image: '/images/fri.png',
    category: 'cart',
    description: 'Friendly Farms effects makes you feel uplifted, happy, and relaxed.',
    effects: ['Relaxing', 'Sleepy', 'Happy'],
    flavors: ['Grape', 'Berry', 'Sweet'],
    cartridgeType: '510 Thread'
  },
  {
    id: 19,
    name: 'Friendly Farms',
    strain: 'Sativa',
    // thcContent: 79,
    price: 30,
    image: '/images/fri2.png',
    category: 'cart',
    description: 'Friendly Farms effects makes you feel uplifted, happy, and relaxed.',
    effects: ['Energetic', 'Happy', 'Creative'],
    flavors: ['Strawberry', 'Sweet', 'Fruity'],
    cartridgeType: '510 Thread'
  },

  // Disposable Carts (4 products)
  {
    id: 23,
    name: 'Boutiq SWITCH V5',
    strain: 'Indica/Sativa',
    // thcContent: 87,
    price: 60,
    image: '/images/jeee.png',
    category: 'disposable-cart',
    isNew: true,
    weight: '2g',
    description: '2-gram disposable with three tanks with different strains and the ability to fire individually or all three at once.',
    effects: ['Relaxing', 'Euphoric', 'Happy'],
    flavors: ['Tropical', 'Sweet', 'Fruity'],
    battery: '320mAh'
  },
  {
    id: 20,
    name: 'Packwoods',
    strain: 'Indica/Sativa',
    // thcContent: 90,
    price: 50,
    image: '/images/pac.png',
    category: 'disposable-cart',
    weight: '2g',
    description: '2 grams premium THC + live resin + liquid diamonds.',
    effects: ['Energetic', 'Creative', 'Uplifted'],
    flavors: ['Pineapple', 'Mango', 'Tropical'],
    battery: '300mAh'
  },
  {
    id: 21,
    name: 'Drip Dual Flavor Disposable',
    strain: 'Indica/Sativa',
    // thcContent: 88,
    price: 50,
    image: '/images/drip.png',
    category: 'disposable-cart',
    weight: '2g',
    description: 'Dual flavors in one 2-gram item, giving a smooth interplay of freshness, strength, and diversity of taste.',
    effects: ['Relaxing', 'Sleepy', 'Happy'],
    flavors: ['Blueberry', 'Sweet', 'Earthy'],
    battery: '350mAh'
  },
  {
    id: 22,
    name: 'MUHA MEDS',
    strain: 'Indica/Sativa',
    // thcContent: 86,
    price: 50,
    image: '/images/raww.png',
    category: 'disposable-cart',
    weight: '2g',
    description: 'Discover the Muha Meds 2gram Live Resin Disposable Vape Pen featuring the "Dragon Berry Runtz" Indica strain.',
    effects: ['Energetic', 'Creative', 'Focused'],
    flavors: ['Orange', 'Citrus', 'Champagne'],
    battery: '300mAh'
  },

  // Pre-rolls (2 products)
  {
    id: 24,
    name: 'Pre-Roll - Sativa',
    strain: 'Sativa',
    // thcContent: 20,
    weight: '1g',
    price: 10,
    image: '/images/prr.png',
    category: 'Pre-rolls',
    description: '1 premium sativa pre-rolls (1g each).',
    effects: ['Our Pre-roll special'],
    flavors: ['10 Sativa Pre-rolls for 80', '20 Sativa Pre-rolls + 1 Edible 160 '],
    quantity: '3 pre-rolls (1g each)'
  },
  {
    id: 25,
    name: 'Pre-Roll - Indica',
    strain: 'Indica',
    weight: '1g',
    // thcContent: 22,
    price: 10,
    image: '/images/prr1.png',
    category: 'Pre-rolls',
    description: '1 premium indica pre-rolls (1g each).',
    effects: ['Our Pre-roll special'],
    flavors: ['10 Indica Pre-rolls for 80', '20 Indica Pre-rolls + 1 Edible 160 '],
    quantity: '3 pre-rolls (1g each)'
  },
  {
    id: 26,
    name: 'Premium Shake - Indica',
    strain: 'Indica',
    weight: '1 oz',
    price: 70,
    image: '/images/shake.png',
    category: 'Shake',
    description: '1 Oz Premium Shake - Indica.',
  },
  {
    id: 27,
    name: 'Premium Shake - Sativa',
    strain: 'Sativa',
    weight: '1 oz',
    price: 70,
    image: '/images/shake.png',
    category: 'Shake',
    description: '1 Oz Premium Shake - Sativa.',
  },
  {
    id: 101,
    name: '1 Exotic Flower + 1 Edible',
    strain: 'Mix & Match',
    weight: '1oz + 1edible',
    price: 180,
    image: '/images/icecake.png',
    category: 'weekly-special',
    description: '1 oz Exotic flower + 1 edible (add flower preference in delivery notes)',
  },
  {
    id: 102,
    name: 'Two Oz Exotics Special',
    strain: 'Mix & Match',
    weight: '2 oz',
    price: 340,
    image: '/images/phaze.png',
    category: 'weekly-special',
    description: 'Your choice of 2 Oz Exoticts flowers (add flowers preference in delivery notes)',
  },
  {
    id: 103,
    name: 'Two Oz Premium Special',
    strain: 'Mix & Match',
    weight: '2 oz',
    price: 180,
    image: '/images/jack.png',
    category: 'weekly-special',
    description: 'Your choice of 2 Oz Premium flowers (add flowers preference in delivery notes)',
  },
  {
    id: 104,
    name: '2 Disposables Special',
    strain: 'Mix & Match 2 disposables',
    weight: '2g each',
    price: 80,
    image: '/images/drip.png',
    category: 'weekly-special',
    description: 'Your choice 2 disposable carts (add disposables preference in delivery notes)',
  },
  {
    id: 105,
    name: '4 Carts Special',
    strain: 'Mix & Match',
    weight: '1g',
    price: 100,
    image: '/images/raw.png',
    category: 'weekly-special',
    description: 'Your choice of 4 Carts (add Carts preference in delivery notes)',
  },
  {
    id: 106,
    name: '5 Edibles Special',
    strain: 'Mix & Match',
    weight: '5 packs',
    price: 100,
    image: '/images/edd.png',
    category: 'weekly-special',
    description: 'Your choice of 5 Edibles',
  },
  {
    id: 107,
    name: '10 pre-rolls Special',
    strain: '10 pre rolls',
    weight: '1g each',
    price: 80,
    image: '/images/prr.png',
    category: 'weekly-special',
    description: '10 premium pre-rolls',
  }
];

export default products;